export const CRUD_SET_VALUE = "CRUD_SET_VALUE";
export const CRUD_SET_VALUE_RECURSIVE = "CRUD_SET_VALUE_RECURSIVE";

export function crudSetValue(setting, value) {
  return {
    type: CRUD_SET_VALUE,
    payload: {
      setting: setting,
      value: value,
    },
  };
}

export function crudSetValueRecursive(path, value) {
  return {
    type: CRUD_SET_VALUE_RECURSIVE,
    payload: {
      path: path,
      value: value,
    },
  };
}
